(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('banner-slider')) {
    customElements.define(
      'banner-slider',
      class extends HTMLElement {
        connectedCallback() {
          const track = this.querySelector('.banner-slider__track');
          const slides = track.children;
          const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

          const go = (dir) => {
            const current = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
            const next = (current + dir + slides.length) % slides.length;
            track.scrollTo({ left: slides[next].offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
          };

          this.querySelector('.banner-slider__btn--prev')?.addEventListener('click', () => go(-1));
          this.querySelector('.banner-slider__btn--next')?.addEventListener('click', () => go(1));

          // Theme editor: jump to the banner being edited
          this.addEventListener('shopify:block:select', (event) => track.scrollTo({ left: event.target.offsetLeft }));

          const seconds = Number(this.dataset.autoplay);
          if (!seconds || slides.length < 2 || reduced || window.Shopify?.designMode) return;

          const stop = () => clearInterval(this.timer);
          const start = () => {
            stop();
            this.timer = setInterval(() => go(1), seconds * 1000);
          };
          this.addEventListener('pointerenter', stop);
          this.addEventListener('pointerleave', start);
          this.addEventListener('focusin', stop);
          this.addEventListener('focusout', start);
          start();
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layered-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('banner-slider')) {
    customElements.define(
      'banner-slider',
      class extends HTMLElement {
        connectedCallback() {
          const track = this.querySelector('.banner-slider__track');
          const slides = track.children;
          const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

          const go = (dir) => {
            const current = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
            const next = (current + dir + slides.length) % slides.length;
            track.scrollTo({ left: slides[next].offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
          };

          this.querySelector('.banner-slider__btn--prev')?.addEventListener('click', () => go(-1));
          this.querySelector('.banner-slider__btn--next')?.addEventListener('click', () => go(1));

          // Theme editor: jump to the banner being edited
          this.addEventListener('shopify:block:select', (event) => track.scrollTo({ left: event.target.offsetLeft }));

          const seconds = Number(this.dataset.autoplay);
          if (!seconds || slides.length < 2 || reduced || window.Shopify?.designMode) return;

          const stop = () => clearInterval(this.timer);
          const start = () => {
            stop();
            this.timer = setInterval(() => go(1), seconds * 1000);
          };
          this.addEventListener('pointerenter', stop);
          this.addEventListener('pointerleave', start);
          this.addEventListener('focusin', stop);
          this.addEventListener('focusout', start);
          start();
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
